import ReactGA from "react-ga4";

export const initGA = () => {
    ReactGA.initialize("G-JZ828FNJ2X");
};

export default ReactGA;